import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SITE } from "@/content/site";

export default function Impressum() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1" data-testid="legal-page-wrapper">
        <div className="site-container section-pad max-w-3xl">
          <p className="kicker">Rechtliches</p>
          <h1 className="mt-4 text-3xl font-semibold tracking-[-0.02em] sm:text-4xl" data-testid="impressum-title">
            Impressum
          </h1>

          <div className="mt-10 space-y-8 text-sm leading-relaxed text-foreground/85">
            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">Kontaktadresse</h2>
              <p className="mt-3">
                {SITE.name}
                <br />
                {SITE.owner}
                <br />
                {SITE.addressLine1}
                <br />
                {SITE.addressLine2}
                <br />
                Schweiz
              </p>
              <p className="mt-3">
                Telefon: {SITE.phoneDisplay}
                <br />
                E-Mail: {SITE.email}
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">Vertretungsberechtigte Person</h2>
              <p className="mt-3">{SITE.owner}, Inhaberin</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">Handelsregister & UID</h2>
              <p className="mt-3">
                Unternehmens-Identifikationsnummer (UID): {SITE.uid}
                <br />
                Handelsregister: Kanton Zürich (ZH)
                <br />
                Status: aktiv
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">Haftungsausschluss</h2>
              <p className="mt-3">
                Der Autor übernimmt keine Gewähr für die Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und
                Vollständigkeit der Informationen. Haftungsansprüche gegen den Autor wegen Schäden materieller oder
                immaterieller Art, die aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten
                Informationen entstanden sind, werden ausgeschlossen.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">Haftung für Links</h2>
              <p className="mt-3">
                Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs. Es wird
                jegliche Verantwortung für solche Webseiten abgelehnt. Der Zugriff und die Nutzung solcher Webseiten
                erfolgen auf eigene Gefahr des Nutzers oder der Nutzerin.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
